<template>
    <div>
        <div
            class="comments"
            :key="comment.id"
            v-for="comment in groupedComments"
        >
            <div class="comment-title">{{ comment.title }}</div>
            <div
                class="networks-comments mb-2"
                :key="network"
                v-for="(networkComments, network) in comment.answersByNetwork"
            >
                <div class="network-title">
                    {{ $t('values.network.types.' + network) + ':' }}
                </div>
                <div
                    class="comment-content"
                    :key="comment.comment_id"
                    v-html="comment.content"
                    v-for="comment in networkComments"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { groupBy, uniq } from 'lodash'
export default {
    props: {
        comments: {
            type: Array,
            required: true,
        },
    },
    computed: {
        groupedComments() {
            return this.questionnaireCommentsIds.map(id => {
                const answers = this.getCommentAnswers(id)
                return {
                    id,
                    title: answers[0].comment_title,
                    answersByNetwork: this.groupCommentAnswersByNetwork(
                        answers
                    ),
                }
            })
        },
        questionnaireCommentsIds() {
            const questionnaireCommentsIds = this.comments.map(
                c => c.questionnaire_comment_id
            )

            return uniq(questionnaireCommentsIds)
        },
    },
    methods: {
        getCommentAnswers(questionnaireCommentId) {
            return this.comments.filter(
                c => c.questionnaire_comment_id == questionnaireCommentId
            )
        },
        groupCommentAnswersByNetwork(answers) {
            return groupBy(answers, 'type')
        },
    },
}
</script>
<style lang="sass" scoped>
::v-deep .comments
    color: #6E6E6E

    .comment-title
        font-weight: 700
        font-size: 15px

    .networks-comments
        .network-title
            font-weight: 700

        .comment-content
            &:after
                display: block
                content: ''
                width: 100%
                margin-top: 10px
                margin-bottom: 10px
                height: 2px
                background-color: rgba(0,0,0,.2)

            &:last-child:after
                height: 0

            *
                margin: 0
                padding: 0
                text-align: justify
</style>
